<cdk-tree [dataSource]="tools" [treeControl]="processorTreeControl" [trackBy]="trackByFn">
    <cdk-tree-node *cdkTreeNodeDef="let tool" class="tree-node">
        <dp-tool-tree-node [tool]="toolsMap[tool.toolId]" [isExpanded]="processorTreeControl.isExpanded(tool)"></dp-tool-tree-node>
    </cdk-tree-node>
</cdk-tree>
